import type { ApiFetchInit } from './api';
import { WriteRefusedError } from './apiProblemError';
import { isImpersonating } from './impersonate-write-mode';

type ApiFetchFn = (input: RequestInfo | URL, init?: ApiFetchInit) => Promise<Response>;

/**
 * A write the rep did not ask for: a usage ping, a debounced view-state save,
 * an unmount cleanup. Resolves `null` without sending while impersonating,
 * even with writes unlocked, because it would change the TARGET user's state.
 * A `WriteRefusedError` (possible before `/api/me` loads) also resolves
 * `null`, with `announceRefusal: false` so it does not toast; any other
 * rejection is rethrown unchanged.
 */
export async function backgroundWrite(
  apiFetch: ApiFetchFn,
  input: RequestInfo | URL,
  init: ApiFetchInit,
): Promise<Response | null> {
  if (isImpersonating()) return null;
  try {
    return await apiFetch(input, { ...init, announceRefusal: false });
  } catch (err) {
    if (err instanceof WriteRefusedError) return null;
    throw err;
  }
}
